import validation from "./validation";
import reset from "./reset";
import maximoConfig from "./maximoConfig";

const middlewares = [validation, reset, maximoConfig];

const getMiddlewaresArray =
  (middlewares) =>
  (slices = {}) => {
    return middlewares.map((middleware) => {
      return middleware(slices);
    });
  };

export default getMiddlewaresArray(middlewares);
